export function getEstimationErrorMessages(variables: any) {
    return {
        "User is not active": variables.userNotActive,
        "You do not have access to this project": variables.notAuthorizedToEditCatalog,
        "Project not active": variables.snackBarMessageProjInactive,
        "Only SUPER-ADMIN or ARCHITECT can add reviews.": variables.notAuthorized,
        "ARCHITECT does not have permission to certify this estimate.": variables.notAuthorized,
        "Access denied to project estimates": variables.notAuthorized,
        "Estimate name required": variables.estimateName,
        "Criticality or complexity values are missing": variables.complexityLevel,
        "Complexity values must be one of 0.1, 0.25, 0.7, 1": variables.complexityValueError,
        "Project ID is missing": variables.projectWBSCode,
        "Catalog ID is missing": variables.catalogIDMissingError,
        "Catalog not found": variables.catalogNotFound,
        "Project methodology must be 'agile' or 'other'": variables.selectProjectMetodology,
        "Estimate mode must be 'complex' or 'tshirt' for agile methodology": variables.estimateModeError,
        "Invalid projectType: must exist with name and risk between 1 and 100": variables.invalidProjectTypeEntries,
        "At least one configuration is required": variables.atLeastOneConfig,
        "Invalid configuration: name required and complexity > 0": variables.invalidConfigurationEntries,
        "At least one macroActivity is required": variables.atLeastOneMacro,
        "SubTasks are required": variables.subTasks,
        "No tools justification is required": variables.noToolsJustification,
        "State must be 'incomplete' or 'complete'": variables.stateRequiredInRequest,
        "Estimate not found": variables.estimate + variables.notFound,
        "Review comment is required.": variables.reviewComment,
        "Estimate must be in 'complete' state.": variables.EstimateAt,
        "Estimate is not in 'complete' state.": variables.EstimateNeedsReview,
        "Folder name cannot be empty": variables.folderNameEmptyError,
        "No estimate IDs provided": variables.noEstimateIDsError,
        "Estimate is not associated": variables.estimateNeedsReview,
        "Project not found": variables.project + variables.notFound,
        "Only owner and SUPER-ADMIN can update the total times of the estimate.": variables.notAuthorizedToUpdateEstimateEffortTimes
    };
}
